angular.module('cerberus.core')
    .controller('nimVizScheduleCalendarCtrl', function($scope) {
        var vm = this;

        vm.options = angular.copy($scope.pageObject.viz.settings);
        // Calendar doesn't need any special configuration yet
    })
;